import { TwoStepResetPasswordSuccess } from './TwoStepResetPasswordSuccess.js';
export default TwoStepResetPasswordSuccess;
//# sourceMappingURL=index.js.map